import React, { useEffect, useState } from "react";
import BeneficiaryTable from "../../BeneficiaryTable/BeneficiaryTable";
import InvalidRecordsSection from "./InvalidRecordsSection";
import { MdNavigateNext } from "react-icons/md";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const ReviewStep = ({
                      beneficiarios,
                      invalidRecords,
                      showInvalidData,
                      onToggleInvalidData,
                      onConfirm,
                      isLoadingSend,
                    }) => {
  const [stateFilter, setStateFilter] = useState("Todos");
  const [allStates, setAllStates] = useState([]);

  useEffect(() => {
    const states = beneficiarios
      .map((b) => b.state)
      .filter((s) => s && s.trim() !== "");
    const uniqueStates = [...new Set(states)];
    setAllStates(uniqueStates);
  }, [beneficiarios]);

  const filteredBeneficiaries =
    stateFilter === "Todos"
      ? beneficiarios
      : beneficiarios.filter((b) => b.state === stateFilter);

  return (
    <div className="w-full max-w-[1180px] bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex items-center justify-between mb-4 gap-4">
        <div>
          <h2 className="text-xl font-medium text-gray-800">
            Revise os dados importados
          </h2>
          <p className="text-gray-600 text-sm mt-1">
            Verifique se as informações estão corretas antes de confirmar o
            registro.
          </p>
        </div>

        <div className="flex flex-col items-end gap-2">
          <FormControl size="small" sx={{ minWidth: 100 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={stateFilter}
              onChange={(e) => setStateFilter(e.target.value)}
              variant="outlined"
              label="Estado"
            >
              <MenuItem value="Todos">Todos</MenuItem>
              {allStates.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <span className="text-sm text-gray-600 text-end">
            {filteredBeneficiaries.length} beneficiário
            {filteredBeneficiaries.length !== 1 && "s"}
          </span>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-6">
        <BeneficiaryTable
          beneficios={filteredBeneficiaries}
          isLoadingSend={isLoadingSend}
        />
      </div>

      <InvalidRecordsSection
        invalidRecords={invalidRecords}
        showInvalidData={showInvalidData}
        onToggleShow={() => onToggleInvalidData(true)}
      />

      <div className="flex justify-end mt-4">
        <button
          className={`flex items-center px-6 py-3 rounded-lg font-medium text-white
            ${
            isLoadingSend
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-emerald-600 hover:bg-emerald-700 focus:ring-2 focus:ring-emerald-400"
          } 
            transition-colors duration-200`}
          onClick={onConfirm}
          disabled={isLoadingSend}
        >
          {isLoadingSend ? (
            <span className="flex items-center">
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2" />
              Processando...
            </span>
          ) : (
            <span className="flex items-center">
              Confirmar registro dos dados
              <MdNavigateNext className="ml-1 text-xl" />
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default ReviewStep;
